// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { IGetAgentInfoRequest, TGetAgentInfoModel, IMappers, TGetAgentInfoResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetAgentInfoResponseV3 } from '../../entities/agent_info/GetAgentInfoResponseV3';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetAgentInfoModel(parameters: IGetAgentInfoRequest): TGetAgentInfoModel {
  return {
    v: 1,
    apiType: 'private',
    method: 'GET',
    microserviceName: 'agent-card',
    pathApi: '/v3/get-agent-info/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetAgentInfoOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetAgentInfoRequest;
}

export async function fetchGetAgentInfo<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetAgentInfoOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetAgentInfoResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetAgentInfoModel(parameters),
    config,
  )) as FetchResponse<TGetAgentInfoResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetAgentInfoResponseV3, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetAgentInfoResponse>;
}
